import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SelectOption } from "../../components/essentials/input/select/AcedSelect";
import http from "../../shared/utils/http";

export const usePositions = (sport: string) => {
	const [roles, setRoles] = useState([]);
	const { t } = useTranslation();
	useEffect(() => {
		http.get("/utils/positions?sport=" + sport).then((response) => {
			setRoles(
				response.map(
					(position: { name: string; value: string }) =>
						({
							value: position.value,
							label: t(
								`sportData.positions.${sport}.${position.value}`,
								position.name
							),
						} as SelectOption)
				)
			);
		});
	}, []);
	return {
		roles,
	};
};
